import { MAP_H, MAP_W, type Pos } from '@xox/shared'

/** Cells the phone board shows at once: a tall window that follows the hero. */
export const VIEW_W = 11
export const VIEW_H = 13

/** Top-left map cell of the window, centred on `hero` and clamped to the map. */
export function cameraFor(hero: Pos, viewW = VIEW_W, viewH = VIEW_H): Pos {
  const c = Math.min(Math.max(0, hero.c - Math.floor(viewW / 2)), MAP_W - viewW)
  const r = Math.min(Math.max(0, hero.r - Math.floor(viewH / 2)), MAP_H - viewH)
  return { r, c }
}
